import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import StaticVoucherGroupTable from './VoucherGroupTable';

interface IStaticVoucherGroupProps extends RouteComponentProps<{
  eshop: string;
  groupId: string;
}> {
}

export default class StaticVoucherGroup extends React.Component<IStaticVoucherGroupProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <StaticVoucherGroupTable
        domain={this.props.match.params.eshop}
        groupId={this.props.match.params.groupId}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticVoucherGroups/index.tsx